// extracted by mini-css-extract-plugin
module.exports = {"networkWrapper":"Category_networkWrapper__2lsDP","menuItem":"Category_menuItem__2GO6_"};